import {
  LogoutOutlined,
  TeamOutlined,
  FileSyncOutlined,
  LineChartOutlined,
  BarChartOutlined,
} from '@ant-design/icons';
//import MiniLogo from '@assets/images/mysg-logo-min.png';
import MiniLogo from '@assets/images/static/img_logo_byes.png';
import { useLingui } from '@lingui/react';
import { Divider, Layout, Menu } from 'antd';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from '~/helpers/store/auth';

const { Sider } = Layout;

type Menu = { key: string; icon: JSX.Element; label: JSX.Element };

function NavBar() {
  const { i18n } = useLingui();
  const [value, setValue] = useState<string>('');
  const { payload } = useAuth();

  const location = useLocation();
  const { pathname } = location;

  useEffect(() => {
    setValue(pathname.substring(1));
  }, [pathname]);

  if (value.length <= 0) {
    return <></>;
  }

  const adminItems = [
    {
      key: 'stats',
      icon: <LineChartOutlined />,
      label: (
        <div>
          {i18n._('common.stats')}
          <Link to="/bo/admin/stats" />
        </div>
      ),
    },
    {
      key: 'trackings',
      icon: <BarChartOutlined />,
      label: (
        <div>
          {i18n._('common.trackings')}
          <Link to="/bo/admin/trackings" />
        </div>
      ),
    },
    {
      key: 'users',
      icon: <TeamOutlined />,
      label: (
        <div>
          {i18n._('common.users')}
          <Link to="/bo/admin/users" />
        </div>
      ),
    },
  ];

  const menuItems = [
    {
      key: 'files',
      icon: <FileSyncOutlined />,
      label: (
        <div>
          {i18n._('common.files')}
          <Link to="/bo/files" />
        </div>
      ),
    },
  ];

  const menuLogout = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: (
        <div>
          {i18n._('common.logout')}
          <Link to="/logout" />
        </div>
      ),
    },
  ];

  /*
  <SDivLogo>
        <Link to="/bo/home">
          <img src={MiniLogo} alt="mini-logo" onClick={() => setValue('')} />
        </Link>
      </SDivLogo>
  */
  return (
    <Sider collapsible breakpoint="lg" theme="light">
      <SDivLogo>
        <img src={MiniLogo} alt="mini-logo" onClick={() => setValue('')} />
      </SDivLogo>
      <Divider />
      <Menu
        theme="light"
        mode="inline"
        style={{ borderInlineEnd: 'none' }}
        defaultSelectedKeys={[value]}
        items={payload?.roles === 'Admin' ? adminItems : menuItems}
      />
      <Divider />
      <Menu
        theme="light"
        mode="inline"
        style={{ borderInlineEnd: 'none' }}
        defaultSelectedKeys={[value]}
        items={menuLogout}
      />
    </Sider>
  );
}

/*
 items={
          payload?.roles === 'Admin'
            ? adminItems.concat(menuItems).concat(menuLogout)
            : menuItems.concat(menuLogout)
        }
*/
export default NavBar;

const SDivLogo = styled.div`
  position: relative;
  height: 8%;
  margin-top: 10px;
  margin-bottom: 10px;
  width: 100%;

  img {
    left: 0;
    top: 0;
    height: 100%;
    object-fit: contain;
    position: absolute;
    width: 100%;
  }
`;
